import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiServiceV2 } from '../services/api.serviceV2';

@Injectable()
export abstract class ShareToUsersService extends ApiServiceV2 {
    constructor(resourceName: string, http: HttpClient) {
        super(resourceName, http);
    }

    public postNewUser(entityId: string, userEmail: string): Observable<void> {
        return this.http.post<void>(super.url(''),
            {
                id: entityId,
                userEmail
            });
    }
    public deleteUser(entityId: string, userEmail: string): Observable<void> {
        return this.http.delete<void>(super.url(''), {
            params:
            {
                id: entityId,
                userEmail
            }
        });
    }
}
